<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <SnackBar ref="snackbar" />
  <v-dialog v-model="dialogConfirmacao" persistent max-width="600">
    <v-card>
      <v-card-title class="headline"> Encerrar Equipe </v-card-title>

      <v-card-text>
        Você tem certeza que deseja encerrar esta equipe?
      </v-card-text>

      <v-card-actions>
        <v-btn color="blue darken-1" dark @click="deleteTeam">Sim</v-btn>
        <v-btn color="red darken-1" dark @click="dialogConfirmacao = false"
          >Não</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-container fluid v-if="funcao == 'Coordenador'">
    <v-data-table
      :headers="headers"
      :items="equipes"
      :sort-by="[{ key: 'nome', order: 'asc' }]"
      class="elevation-1"
    >
      <template #top>
        <v-toolbar flat>
          <v-toolbar-title style="font-size: 22px; font-weight: bold"
            >Equipes</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <ModalCadastrarEquipe style="margin-right: 40px" />
        </v-toolbar>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="justify-content-center">
          <v-tooltip text="Visualizar Equipe" location="bottom">
            <template #activator="{ props }">
              <v-icon
                v-bind="props"
                size="small"
                class="me-2"
                @click="showItem(item.raw)"
              >
                mdi-eye
              </v-icon>
            </template>
          </v-tooltip>
          <v-tooltip text="Editar Equipe" location="bottom">
            <template #activator="{ props }">
              <v-icon
                v-bind="props"
                size="small"
                class="me-2"
                @click="editItem(item.raw)"
              >
                mdi-pencil
              </v-icon>
            </template>
          </v-tooltip>
          <v-tooltip text="Excluir Equipe" location="bottom">
            <template #activator="{ props }">
              <v-icon
                v-bind="props"
                size="small"
                class="me-2"
                color="red"
                @click="chamarDialogExcluir(item.raw)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-tooltip>
        </div>
      </template>
      <template #no-data>
        <div class="text-center py-6">
          <span> Sem equipes a listar </span>
        </div>
      </template>
    </v-data-table>
  </v-container>
  <ModalListarEquipe
    style="margin-right: 40px"
    @solicitacaoFechar="atualizarEstado"
    :ativo="true ? equipeDialog : false"
    :nomeEquipe="this.nomeEquipe"
    :equipe="this.equipeMembros"
  />
  <ModalEditarEquipe
    v-if="equipeDialogEdit"
    style="margin-right: 40px"
    @solicitacaoFechar="atualizarEstadoEdit"
    @attDados="atualizarDados"
    :ativo="true ? equipeDialogEdit : false"
    :nomeEquipe="this.nomeEquipe"
    :equipe="this.equipeMembros"
    :ids="this.ids"
    :id="this.id_equipe"
  />
</template>

<script>
import axios from 'axios';
import { VDataTable } from 'vuetify/labs/VDataTable';

import ModalCadastrarEquipe from '@/components/dialogs/ModalCadastrarEquipe.vue';
import ModalEditarEquipe from '@/components/dialogs/ModalEditarEquipe.vue';
import ModalListarEquipe from '@/components/dialogs/ModalListarEquipe.vue';
import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    VDataTable,
    ModalListarEquipe,
    ModalCadastrarEquipe,
    ModalEditarEquipe,
    SnackBar,
  },
  data: () => ({
    equipeId: null,
    dialogConfirmacao: false,
    funcao: null,
    equipeDialog: false,
    equipeDialogEdit: false,
    nomeEquipe: null,
    // eslint-disable-next-line camelcase
    id_equipe: null,
    headers: [
      {
        title: 'Nome da Equipe',
        align: 'start',
        key: 'nome',
      },
      { title: 'Organização', key: 'git_org', sortable: true },
      { title: 'Ações', key: 'actions', sortable: false },
    ],
    equipes: [],
    ids: [],
    equipeMembros: [],
    attDados: false,
    itemId: null,
  }),

  created() {
    this.fetchEquipes();
    this.funcao = store.state.funcao;
  },

  methods: {
    chamarDialogExcluir(item) {
      this.equipeId = item.id;
      this.dialogConfirmacao = !this.dialogConfirmacao;
    },
    atualizarEstado(dadosDoFilho) {
      this.equipeDialog = dadosDoFilho.solicitacao;
      this.nomeEquipe = null;
      this.equipeMembros = [];
    },
    atualizarEstadoEdit(dadosDoFilho) {
      this.equipeDialogEdit = dadosDoFilho.solicitacao;
      this.nomeEquipe = null;
      this.equipeMembros = [];
    },
    atualizarDados(dadosDoFilho) {
  this.attDados = dadosDoFilho;

  axios
    .get(`${API_URL}/equipes/visualizar/${this.attDados}`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      },
    })
    .then((response) => {
      this.equipeMembros = response.data.map((equi) => ({
        nomeEqui: equi.tb_usuario.nome,
        formaAtuacao: equi.forma_atuacao,
        userGit: equi.tb_usuario.usuario_git,
        foto: equi.tb_usuario.img_url,
      }));

      this.ids = response.data.map((equi) => equi.id_usuario);

      this.equipeDialogEdit = true;
    })
    .catch((error) => {
      console.error(error);
    });
},
    showItem(item) {
      this.nomeEquipe = item.nome;
  this.equipeMembros = [];
  this.ids = [];

  axios
    .get(`${API_URL}/equipes/visualizar/${item.id}`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      },
    })
    .then((response) => {
      response.data.forEach((equi) => {
        this.equipeMembros.push({
          nomeEqui: equi.tb_usuario.nome,
          formaAtuacao: equi.forma_atuacao,
          userGit: equi.tb_usuario.usuario_git,
          foto: equi.tb_usuario.img_url,
        });
      });

      this.equipeDialog = true;
    })
    .catch((error) => {
      console.error(error);
    });
    },
    editItem(item) {
      this.nomeEquipe = item.nome;
      this.equipeMembros = [];
      this.itemId = item.id;
      // eslint-disable-next-line camelcase
      this.id_equipe = item.id;
      axios
        .get(`${API_URL}/equipes/visualizar/${item.id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          console.log(response.data)
          this.equipeMembros = response.data.map((equi) => ({
    nomeEqui: equi.tb_usuario.nome,
    formaAtuacao: equi.forma_atuacao,
    userGit: equi.tb_usuario.usuario_git,
    foto: equi.tb_usuario.img_url,
  }));

  this.ids = response.data.map((equi) => equi.id_usuario);

  this.equipeDialogEdit = true;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fetchEquipes() {
      this.nomeEquipe = null;
      this.equipeMembros = [];
      this.equipes = [];

      axios
        .get(API_URL + '/equipes', {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.equipes = response.data.map((equipe) => ({
            id: equipe.id_equipe,
            nome: equipe.nome_equipe,
            // eslint-disable-next-line camelcase
            git_org: equipe.git_org,
          }));
          this.nomesEquipes = this.equipes.map((equipe) => equipe.nome);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    deleteTeam() {
      axios
        .delete(`${API_URL}/equipes/${this.equipeId}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then(() => {
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Equipe encerrada com sucesso!',
          );
          this.dialogConfirmacao = !this.dialogConfirmacao;
          location.reload();
        })
        .catch((error) => {
          this.$refs.snackbar.showErrorSnackbar(
            'Erro!',
            'Não foi possível encerrar a Equipe!',
          );
          console.error(error);
        });
    },
  },
};
</script>
